import {check, uncheck} from "../intouch.js";
import {skin} from "../utils/Skin.js";
import {msg} from "../i18n/Message.ts";

export const SEARCH_CONTEXTS = {
	searchIn : msg("searchWidget.searchIn"),
	searchAnd : msg("searchWidget.searchAnd"),
	searchAll : msg("searchWidget.searchAll")
};
export const searchOptions = [];


let	inputElm = null;
let inputElmID = null;
let optionsElm = null;
let rows = 0;
let actions = null;
let selrow = -1;
const inSearchOptions = false;
const hideMenuInterval = null;
let optionsOpen = false;

function openSearchOptions() {
	if (!optionsOpen) {
		$('#searchOptionsBox').slideDown(200);
		$('#searchOptions .opener').removeClass('closed');
		optionsOpen = true;
		hideSuggestions();
		$('#searchWidget').addClass('openOptions');
	}
}

function closeSearchOptions() {
	if (optionsOpen) {
		$('#searchOptionsBox').slideUp(200);
		$('#searchOptions .opener').addClass('closed');
		optionsOpen = false;
		setTimeout(function() { $('#searchWidget').removeClass('openOptions'); }, 200);
	}
}

function toggleSearchOptions() {
	if (optionsOpen) {
		closeSearchOptions();
	} else {
		openSearchOptions();
	}
}

function searchOptionsChanged(optionCheckbox) {
	const n = optionCheckbox.attr('name');
	const state = optionCheckbox.is(':checked');
	if (n == 'searchAll') {
		if (state) searchUncheckOptions();
		else {
			check('qbeForm', 'search(CU)');
		}
	} else {
		if (state || isAnySearchOptionChecked()) uncheck('qbeForm', 'searchAll');
		else check('qbeForm', 'searchAll');
	}
	setSearchOptionsCookies();
	setSearchInputPlaceholder();
}
function isAnySearchOptionChecked() {
	const el = document.forms['qbeForm'].elements;
	for (let i= 0; i < searchOptions.length; i++) {
		const chbox = el[checkboxName(searchOptions[i])];
		if (!chbox) continue;
		if (chbox.checked) return true;
	}
	return false;
}

function setSearchOptionsCookies() {
	let el = document.forms['qbeForm'].elements;
	if (el['searchAll'].checked) localStorage.setItem("searchAll", "true");
	else localStorage.removeItem("searchAll");

	for (let i= 0; i < searchOptions.length; i++) {
		let chbox = el[checkboxName(searchOptions[i])];
		if (!chbox) continue;
		if (chbox.checked) localStorage.setItem(searchOptions[i], "true");
		else localStorage.removeItem(searchOptions[i]);
	}
}

/**
 * Initialize search field
 * @param {string} inputID - DOM ID of input field
 * @param {string} iconColor
 */
export function initSearch(inputID, iconColor) {
	if (inputElm != null) return; // already initialized
	inputElm = $('#'+inputID);
	if (inputElm.length != 1) {
		alert('Invalid search input ID '+inputID);
		return;
	}
	inputElmID = inputID;

	optionsElm = $('#searchOptionsBox');
	$('#searchOptions').click(function(){
		toggleSearchOptions();
	});

	inputElm.on("input", (event) => {sgKeyUp(event);});
	//inputElm.keyup(function(event) { sgKeyUp(event); });
	inputElm.keydown(function(event) { return sgKeyDown(event); });
	inputElm.blur(function(event) {
		setTimeout(function() {hideSuggestions();}, 200);
		return true; });
	inputElm.focus(function(event) {
		if (optionsOpen) closeSearchOptions();
		invalidateSearchCache();
		sgKeyUp(event);
	});
	inputElm.after('<div class="suggestions" id="sg_'+inputID+'"></div>');

	optionsElm.find('input[type=checkbox]').change(function(e) { searchOptionsChanged($(this)); });

	let isAlt = false;
	$(document).keyup(function (e) {
		if(e.which === 18) isAlt=false;
		}).keydown(function (e) {
		    if(e.which === 18) isAlt=true;
		    //if((e.which == 88 /* x */ && isAlt == true) || e.which == 119 /* F8 */) {
			if(e.which === 119 /* F8 */) {
		        inputElm.val('');
		        inputElm.focus();
		        return false;
		 }
		});
}

let searchCache = {};

function sgKeyUp(event) {
	const fulltext = true;	//!($('#filterSearchCheck').is(':checked') || $('#phoneBookSearchCheck').is(':checked'));
	const cval = inputElm.val();
	if (cval.trim().length < 2 || !fulltext) {
		searchCache = {};	// empty cache
		hideSuggestions();
		//displayOptions();
		return;
	}
	let nativeElm = inputElm.get(0);
	let selectionStart = nativeElm.selectionStart;
	let selectionEnd = nativeElm.selectionEnd;
	let cursorPos;
	if (selectionStart === selectionEnd) cursorPos = selectionStart;
	else cursorPos = -1;

	queryServerWith(cval, cursorPos);
}

let justSearching = null;
let searchInQueue = null;
let cursorInQueue = -1;
let lastQuery = null;

function invalidateSearchCache() {
	searchCache = {};
	lastQuery = null;
}

/**
 * @param {string} query
 * @param {number} cursorPosition
 */
function queryServerWith(query, cursorPosition) {
	if (lastQuery != null && lastQuery == query) {
		//console.log("DUP with last "+query);
		return;
	}
	if (justSearching != null) {
		// Search in progress
		if (query != justSearching) {
			searchInQueue = query;
			cursorInQueue = cursorPosition;
		}
		return;
	}
	justSearching = query;
	lastQuery = query;
	const cdata = searchCache[query];
	if (cdata != null) {	// serve from cache
		//console.log("FOUND IN CACHE "+query);
		searchDone(cdata);
		searchAlways(cdata);
		return;
	}
	const data = {};
	data['q'] = query;
	data['cursor'] = cursorPosition.toString();
	optionsElm.find('input[type=checkbox]').each(function () {
		if ($(this).is(':checked')) {
			data[$(this).attr('name')] = 'on';
		}
	});
	jQuery.ajax('searchfeed.do', { data: data, type: 'POST' })
	.done(function(data) {
		//console.log("FROM SERVER "+query);
		searchCache[query] = data;	// remember
		searchDone(data);
	})
	.fail((jqXHR, textStatus, errorThrown) => {
		console.log("FAIL AJAX "+JSON.stringify(jqXHR)+" ... "+textStatus+" ... "+errorThrown);
	})
	.always(function(data) {
		searchAlways(data);
	});
}
function searchDone(data) {
	displaySuggestions(data.items);
}
function searchAlways(data) {
	const siq = searchInQueue;
	const ciq = cursorInQueue;
	justSearching = null;
	searchInQueue = null;
	cursorInQueue = null;
	if (siq != null) {
		//console.log("SEARCHING FROM QUEUE "+siq);
		queryServerWith(siq, ciq);
	} //else console.log("NOTHING TO DO");
}

function sgKeyDown(e) {
	if (rows === 0) return true;	// nothing to select

	if (e.keyCode === 38 /* UP */) {
		if (selrow <= 0) selectRow(rows-1);
		else selectRow(selrow-1);
		return false;
    }
	else if (e.keyCode === 40 /* DOWN */) {
		if (selrow >= (rows-1)) selectRow(0);
		else selectRow(selrow+1);
		return false;
    }
	else if (e.keyCode === 13 /* ENTER */) {
		if (selrow < 0) return true;
		doAction(selrow);
		return false;
    }
	else if (e.keyCode === 27 /* ENTER */) inputElm.blur();
}

function sgKeyPress(event) {

}

function selectRow(rownum)
{
	if (selrow >= 0) $('#sgRow'+selrow).removeClass("sg-selrow");
	$('#sgRow'+rownum).addClass("sg-selrow");
	selrow = rownum;
}


function displaySuggestions(slist)
{
	let scont = $('#sg_'+inputElmID);
	if (slist == null || slist.length === 0) {
		scont.hide();
		return;	// nothing to show
	}
	scont.empty();
	selrow = -1;
	rows = 0;
	actions = [];
	for (let i = 0; i < slist.length; i++)
	{
		let html;
		let	item = slist[i];
		const row = $("<div></div>");
		row.attr("id", "sgRow" + rows).addClass("sg-row").attr("data-row", rows.toString());
		let searchIcon = skin.iconTag(item.icon, null);
		//console.log("Icon = " + item.icon);
		$("<div></div>").addClass("sg-icon")
			.append(searchIcon).appendTo(row);
		$("<div></div>").addClass("sg-title").text(item.title).appendTo(row);
		row.on("mouseover", function() {
			selectRow(parseInt($(this).attr("data-row")));
		}).on("click", function() {
			doAction(parseInt($(this).attr("data-row")));
		});

		/*html = "<div id=\"sgRow"+rows+"\" class=\"sg-row\" onmouseover=\"selectRow("+rows+");\" onclick=\"doAction("+rows+");return false;\">";
		html += "<div class=\"sg-icon\"><img src=\""+item.icon+"\"></div>";
		html += "<div class=\"sg-title\">"+item.title+"</div>";
		html += "</div>";*/
		scont.append(row);
		rows++;
		actions.push(item.url);
	}
	// set position
	showUnderInput(scont);
}

function showUnderInput(panel)
{
	panel.show();
	const suggPos = inputElm.offset();
	suggPos.top += inputElm.outerHeight()+1;
	panel.offset(suggPos);
	panel.width(inputElm.outerWidth());
}

function doAction(itemIdx)
{
	const loc = actions[itemIdx];
	if (loc !== '#') window.location = loc;
}

function hideSuggestions()
{
	const scont = $('#sg_' + inputElmID);
	scont.hide();
	rows = 0;
	selrow = -1;
	scont.empty();
}


export function searchFormCheckboxTick(sf, ops, name) {
	if(localStorage.getItem(name) === 'true') {
		sf[checkboxName(name)].checked=true;
		ops.push(name);
		return true;
	}
	return false;
}

/**
 * Extract search type from name "search(TYPE)"
 */
function searchType(checkboxName) {
	const start = checkboxName.indexOf("(");
	if (start > 0) {
		const end = checkboxName.indexOf(")");
		if (end > 0) {
			return checkboxName.substring(start + 1, end);
		}
	}
	return checkboxName;
}

function checkboxName(searchType) {
	return "search("+searchType+")";
}

export function setSearchInputPlaceholder() {
	const checkedStuff = [];

	$('#searchOptionsBox').find('input[type=checkbox]').each(function () {
		if ($(this).is(':checked')) {
			const n = $(this).attr('name');
			if (n !== 'searchAll') {
				checkedStuff.push(searchType(n));
			}
		}
	});

	if (checkedStuff.length==0) $('#qbeSearch').attr('placeholder', SEARCH_CONTEXTS.searchAll);
	else {
		let ph = SEARCH_CONTEXTS.searchIn;
		let counter = 0;
		for (let i = 0; i < checkedStuff.length; i++) {
			const item = SEARCH_CONTEXTS[checkedStuff[i]];
			const separ = counter == 0 ? ' ' : (i == (checkedStuff.length - 1) ? ' '+SEARCH_CONTEXTS.searchAnd : ', ');
			if (item) {
				if (counter>=3) {
					ph = ph + ', …';
					break;
				}
				ph = ph + separ + item;
				counter++;
			}
		}
		$('#qbeSearch').attr('placeholder', ph);
	}
}

function searchUncheckOptions() {
	for (let i = 0; i < searchOptions.length; i++) {
		uncheck('qbeForm', checkboxName(searchOptions[i]));
	}
}

